import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ImpersonationMode } from '../../types/Impersonation';

interface ImpersonationModePickerProps {
  selectedMode: ImpersonationMode;
  onModeChange: (mode: ImpersonationMode) => void;
}

interface ModeOption {
  value: ImpersonationMode;
  label: string;
  description: string;
}

const MODE_OPTIONS: ModeOption[] = [
  {
    value: 'full_access',
    label: 'Full Access',
    description: 'You can view and modify data as this user',
  },
  {
    value: 'read_only',
    label: 'Read Only',
    description:
      'You can only view data \u2014 all edit controls will be disabled',
  },
];

export const ImpersonationModePicker: React.FC<
  ImpersonationModePickerProps
> = ({ selectedMode, onModeChange }) => {
  return (
    <View style={styles.container} accessibilityRole="radiogroup">
      {MODE_OPTIONS.map(option => {
        const isSelected = selectedMode === option.value;
        return (
          <TouchableOpacity
            key={option.value}
            style={[styles.option, isSelected && styles.optionSelected]}
            onPress={() => onModeChange(option.value)}
            accessibilityRole="radio"
            accessibilityLabel={option.label}
            accessibilityState={{ checked: isSelected }}
          >
            <View style={styles.radioRow}>
              <View
                style={[
                  styles.radioOuter,
                  isSelected && styles.radioOuterSelected,
                ]}
              >
                {isSelected && <View style={styles.radioInner} />}
              </View>
              <Text style={[styles.label, isSelected && styles.labelSelected]}>
                {option.label}
              </Text>
            </View>
            <Text style={styles.description}>{option.description}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: 8,
    marginVertical: 12,
  },
  option: {
    borderWidth: 1,
    borderColor: '#dee2e6',
    borderRadius: 8,
    padding: 12,
  },
  optionSelected: {
    borderColor: '#0d6efd',
    backgroundColor: '#f0f6ff',
  },
  radioRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 4,
  },
  radioOuter: {
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 2,
    borderColor: '#adb5bd',
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioOuterSelected: {
    borderColor: '#0d6efd',
  },
  radioInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#0d6efd',
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#212529',
  },
  labelSelected: {
    color: '#0d6efd',
  },
  description: {
    fontSize: 12,
    color: '#6c757d',
    marginLeft: 26,
  },
});
